import React, { useState, useEffect } from "react";
import axios from 'axios';
import Swal from 'sweetalert2';
import { useParams } from 'react-router-dom';
import {baseUrl, baseimgUrl, userLocation, ipAddress, userName} from '../Univ.js'
function EditPatient() {

  const {patId}=useParams();

  const [errorMsg, seterrorMsg] = useState('');
  const [gender, setGender] = useState("male"); // set default value to "male"
  const [succesMsg, setsuccessMsg] = useState('');
  const [registerFormData, setRegisterFormData] = useState({
        "my_title":'',
        "pat_id":'',
        "patient":'',
        "age":'',
        "mobile":'',
        "address1":'',
        "gender":'',
        "refered":'',
        "status":'',
        "addedby":'',
        "ip_add":'',
    });
    useEffect(() => {
        try{
            axios.get(baseUrl+'edit-patient/'+patId)
            .then(function (response) {
                setRegisterFormData({
                    my_title:response.data.my_title,
                    pat_id:response.data.pat_id,
                    patient:response.data.patient,
                    age:response.data.age,
                    refered:response.data.refered,
                    mobile:response.data.mobile,
                    address1:response.data.address1,
                    gender:response.data.gender,
                });
            });
        }catch(error){
            console.log(error);
        }
    },[]);
  const handleInputChange = (event) => {
    setGender(event.target.value);
  };
  const inputHandler = (event) => {
        setRegisterFormData({
            ...registerFormData,
            [event.target.name]:event.target.value
        })
  };

  const submitHandler = (e) => {
     e.preventDefault();
        const formData = new FormData();
        const refered = document.getElementById("refered").value;
        const title = document.getElementById("title").value;
        const pat_id = document.getElementById("pat_id").value;
        formData.append('pat_id',pat_id);
        formData.append('my_title',title);
        formData.append('patient',registerFormData.patient);
        formData.append('age',registerFormData.age);
        formData.append('gender',gender);
        formData.append('mobile',registerFormData.mobile);
        formData.append('address1',registerFormData.address1);
        formData.append('refered',refered);
        formData.append('status', '1');
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
          formData.append('location', userLocation);

        axios.put(baseUrl+'edit-patient/'+patId, formData)
          .then((response) => {
              if(response.status==200 || response.status==201){
                Swal.fire({
                  title: 'Patient has been added.',
                  icon: 'success',
                  timer: 5000,
                  showConfirmButton: false
                });
                setTimeout(() => {
                  window.location.href = '/bill-details/'+pat_id;
                }, 3000);
              }
            })
              .catch(error => {
              console.log(error);
                  Swal.fire(
                    'Error!',
                    'Failed to add Patient. Please try again later.',
                    'error'
                  );
              });
  };

  return (
        <section className="container mt-4">
            <div className="row">
              <div className="col-md-8 col-12">
                <div className='card'>
                    <h4 className='card-header text-center'>Edit Patient</h4>
                    <div className='card-body'>
                        <p className="text-muted"><strong>Note:</strong>All are Mandatory Fields</p>
                        {succesMsg && <p className="text-success">{succesMsg}</p>}
                        {errorMsg && <p className="text-danger">{errorMsg}</p>}
                        <form>
                        <div className="row">
                        <label htmlFor="Role" className="form-label">Patient Name</label>
                        <div className="col-md-3 mb-3">
                              <select className="form-control" value={registerFormData.title} onChange={inputHandler}
                                name="title" id="title">
                                <option value="Mr">Mr</option>
                                <option value="Mrs">Mrs</option>
                                <option value="Master">Master</option>
                                <option value="Dr">Dr</option>
                                <option value="Baby">Baby</option>
                                <option value="Ms">Ms</option>
                              </select>
                        </div>
                        <div className="col-md-9 mb-3">
                        <input type="hidden" className="form-control" name="pat_id" id="pat_id"
                            value={registerFormData.pat_id} />
                            <input type="text" placeholder="Patient Name" className="form-control"
                               name="patient" value={registerFormData.patient} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Age" className="form-label">Age</label>
                            <input type="text" placeholder="Age" className="form-control"
                               name="age" value={registerFormData.age} onChange={inputHandler} />
                        </div>
                        <div className="col-md-3 mb-3">
                            <label htmlFor="Mobile" className="form-label">Mobile</label>
                            <input type="number" maxLength={10} placeholder="Mobile" className="form-control"
                                name="mobile" value={registerFormData.mobile} onChange={inputHandler} />
                        </div>
                        <div className="col-md-6 mb-3">
                            <label htmlFor="Address" className="form-label">Address</label>
                            <input type="text" placeholder="Address" className="form-control"
                               name="address1" value={registerFormData.address1} onChange={inputHandler} />
                        </div>
                        </div>
                        <div className="row">

                        <div className="col-md-6 mb-3">
                        <label htmlFor="Gender" className="form-label">Gender</label>
                            <label className="radio-inline">

                            <input type="radio" name="gender" value="male" checked={gender === "male"}
                             onChange={handleInputChange}/> Male
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="female" checked={gender === "female"}
                             onChange={handleInputChange} /> Female
                            </label>
                            <label className="radio-inline">
                            <input type="radio" name="gender" value="transgender" checked={gender === "transgender"}
                             onChange={handleInputChange} /> Transgender
                            </label>
                        </div>
                        <div className="col-md-3 mb-3">
                        <label htmlFor="Refered" className="form-label">Referred By</label>
                            <select className="form-control" value={registerFormData.refered} onChange={inputHandler}
                              name="refered" id="refered">
                            <option value="walkin">Walk-in</option>
                            <option value="medicalcamp">Medical Campaign</option>
                            <option value="friends">Friends</option>
                            <option value="doctor">Doctor</option>
                            <option value="paperad">Paper Adv</option>
                            <option value="others">Others</option>
                            </select>
                        </div>
                        </div>
                        <div className="row">
                        <div className="col-md-12 text-center">
                        <button type="button"  onClick={submitHandler}
                        className="btn btn-success">Edit</button>
                        </div>
                        </div>
                        </form>
                    </div>
                </div>
              </div>
            </div>
        </section>
  );
}

export default EditPatient;
